import { render, staticRenderFns } from "./TaskBlockCommentAction.vue?vue&type=template&id=1ad5ae4a&"
import script from "./TaskBlockCommentAction.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentAction.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockCommentAction.vue?vue&type=style&index=0&id=1ad5ae4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports